/**
 * Theme type definitions for the Adieuu theme customisation system.
 *
 * Themes are pure CSS custom property overrides. Each token in
 * ThemeColorTokens maps to a CSS variable defined in the design system
 * (:root in styles.scss). The mapping is handled by TOKEN_TO_CSS_VAR.
 *
 * @module types/theme
 */
/**
 * Mapping from camelCase token keys to CSS custom property names.
 * Kept as a const object so both runtime and type-level code can use it.
 */
export const TOKEN_TO_CSS_VAR = {
    bgPrimary: '--color-bg-primary',
    bgSecondary: '--color-bg-secondary',
    bgTertiary: '--color-bg-tertiary',
    bgElevated: '--color-bg-elevated',
    bgHover: '--color-bg-hover',
    bgActive: '--color-bg-active',
    textPrimary: '--color-text-primary',
    textSecondary: '--color-text-secondary',
    textMuted: '--color-text-muted',
    textInverse: '--color-text-inverse',
    accentPrimary: '--color-accent-primary',
    accentPrimaryHover: '--color-accent-primary-hover',
    accentPrimaryActive: '--color-accent-primary-active',
    accentSecondary: '--color-accent-secondary',
    accentGlow: '--color-accent-glow',
    border: '--color-border',
    borderMuted: '--color-border-muted',
    borderFocus: '--color-border-focus',
    success: '--color-success',
    successBg: '--color-success-bg',
    warning: '--color-warning',
    warningBg: '--color-warning-bg',
    error: '--color-error',
    errorBg: '--color-error-bg',
    info: '--color-info',
    infoBg: '--color-info-bg',
    danger: '--color-danger',
    logoPrimary: '--logo-primary',
    logoSecondary: '--logo-secondary',
};
/** All valid token keys (typed array for iteration). */
export const THEME_TOKEN_KEYS = Object.keys(TOKEN_TO_CSS_VAR);
//# sourceMappingURL=theme.js.map